import type { TranslatedString } from '@interfaces/shared';
import type { Holding } from '@interfaces/stats';
import { PageObjectType } from '@pages/setting/PageConfigurationDetail/pageConfigurationTypes';
import { BookValueType } from '@providers/statsHooks';

export const find1Day = (hold: Holding, history: any[]) =>
  history[history.length - 1]?.holdings?.find(
    (h: Holding) => h.financialProduct?.id === hold.financialProduct?.id,
  );

export const find3Day = (hold: Holding, history: any[]) =>
  history[history.length - 3]?.holdings?.find(
    (h: Holding) => h.financialProduct?.id === hold.financialProduct?.id,
  );

export const find1Week = (hold: Holding, history: any[]) =>
  history[history.length - 7]?.holdings?.find(
    (h: Holding) => h.financialProduct?.id === hold.financialProduct?.id,
  );

export const find1Month = (hold: Holding, history: any[]) =>
  history[0]?.holdings?.find(
    (h: Holding) => h.financialProduct?.id === hold.financialProduct?.id,
  );

export const bookValueMap = (objectType: PageObjectType): BookValueType => {
  const types = {
    [PageObjectType.INDIVIDUAL as string]: BookValueType.USER,
    [PageObjectType.NON_INDIVIDUAL as string]: BookValueType.USER,
    [PageObjectType.GOAL as string]: BookValueType.GOAL,
    [PageObjectType.SUB_ACCOUNT as string]: BookValueType.SUB_ACCOUNT,
    [PageObjectType.ACCOUNT as string]: BookValueType.ACCOUNT,
    [PageObjectType.HOUSEHOLD as string]: BookValueType.CLIENT_GROUP,
  };

  return types[objectType];
};

export const groupHoldingsByCurrency = (holdingData: Holding[]) => {
  const groupedData = holdingData.reduce(
    (acc, holding) => {
      const currency = holding?.originalCurrency?.currency;
      if (!currency) return acc;

      acc[currency] = acc[currency] || [];
      acc[currency].push(holding);

      return acc;
    },
    {} as Record<string, Holding[]>,
  );

  return groupedData;
};

export const maxNumberOfDecimalPlaces = (holdings: Holding[]) => {
  const decimals = (holdings || []).map((holding) => {
    const [, decimal] = (holding.quantity ?? 0).toString().split('.');
    return decimal ? decimal.length : 0;
  });
  return decimals.length > 0 ? Math.max(...decimals) : 0;
};

export const appendCurrencyToLabel = (
  label: TranslatedString,
  suffix: string,
): TranslatedString => {
  if (!label || !suffix) return label;

  const newLabel: Record<string, string> = {};
  for (const key in label) {
    if (Object.hasOwn(label, key)) {
      newLabel[key] = `${label[key as keyof TranslatedString] || ''}${suffix}`;
    }
  }
  return newLabel as TranslatedString;
};
